import { EnquiryFormType } from "@components/EnquiryForm/types";
import { LOGIN_SESSION_COOKIE, NEW_USER_COOKIE, USER_DISPLAY_NAME_COOKIE, USER_EMAIL_COOKIE, USER_GUESTS_COOKIE, USER_LOCATION_COOKIE, USER_PHONE_COOKIE, USER_VENUE_ID_COOKIE, USER_VENUE_NAME_COOKIE, USER_WEDDING_DATE_COOKIE } from "@helper/constants";
import { setCookie } from "@helper/cookies";
import axios from "axios";

export const submitEnquiry = (data: EnquiryFormType, request: string): Promise<EnquiryResponse | null> => {
    return axios.post('/api/easydirectoryapi/submit-enquiry', request, { headers: { 'Content-Type': 'application/json' } })
    .then((response) => {
        if(response.status === 200) {
            const responseData = response.data as EnquiryResponse;
            const oneDayInSeconds = 24 * 60 * 60;

            if(responseData.isNewUser && responseData.newUserSessionId) {
                setCookie(NEW_USER_COOKIE, data.email, oneDayInSeconds);
                setCookie(LOGIN_SESSION_COOKIE, `LoginUserApiSessionId=${responseData.newUserSessionId}`, oneDayInSeconds);
                setCookie(USER_DISPLAY_NAME_COOKIE, data.name, oneDayInSeconds);
                setCookie(USER_EMAIL_COOKIE, data.email, oneDayInSeconds);
                setCookie(USER_LOCATION_COOKIE, data.regionId?.toString(), oneDayInSeconds);
                setCookie(USER_PHONE_COOKIE, data.phone, oneDayInSeconds);
                setCookie(USER_WEDDING_DATE_COOKIE, data.date?.toString(), oneDayInSeconds);
                setCookie(USER_GUESTS_COOKIE, data.guests?.toString(), oneDayInSeconds);
                setCookie(USER_VENUE_ID_COOKIE, data.venueId?.toString(), oneDayInSeconds);
                setCookie(USER_VENUE_NAME_COOKIE, data.venueName, oneDayInSeconds);
            }

            return responseData;
        }

        return null;
    })
    .catch(() => {
        return null;
    })    
};

export interface EnquiryResponse {
    hasError: boolean;
    errorMessage: string;
    isNewUser: boolean;
    newUserSessionId: string;
    supplierId: number;
}
